import {generateUUID} from '../../../../utility/uuidUtil';
import {FormBuilderComponentTypes} from './ComponentList';

export const getComponentByType = (type) => {
    switch (type) {
        case 'singleText':
            return {
                type, label: 'Single Text Line Question', description: '', validation: {min: 1, max: 50},
            };
        case 'textBox':
            return {
                type, label: 'Textbox Question', description: '',
            };
        case 'multiLineInput':
            return {
                type,
                label: 'Multiple Inputs Question',
                description: '',
                inputs: [{id: generateUUID(), title: '' }, {id: generateUUID(), title: '' }]
            };
        case 'appointmentBooking':
            return {
                type, label: 'Appointment Booking', description: '', bookingUrl: ''
            };
        case 'payment':
            return {
                type, label: 'Payment', description: '', paymentUrl: ''
            };
        case 'checkboxQuestion':
            return {
                type, label: 'Checkbox Question', description: '', value: false
            };
        case 'signature':
            return {
                type, label: 'Signature'
            };
        case 'additionalNotes':
            return {
                type, label: 'Notes', description: '',
            };
        case 'attachment':
            return {
                type, label: 'Attachment', description: '', attachments: [],
            };
        case 'image':
            return {
                type, label: 'Image', description: '', attachments: [],
            };
        case 'multipleChoice':
            return {
                type,
                label: 'Multiple Choice Question',
                description: '',
                options: [{id: generateUUID(), description: ''}, {
                    id: generateUUID(),
                    description: ''
                }, {id: generateUUID(), description: ''}],
            };
        case 'singleChoice':
            return {
                type,
                label: 'Single Choice Question',
                description: '',
                options: [{id: generateUUID(), description: ''}, {
                    id: generateUUID(),
                    description: ''
                }, {id: generateUUID(), description: ''}],
            };
        case 'linearScale':
            return {
                type,
                label: 'Linear Scale',
                description: '',
                startFrom: 1,
                endAt: 5,
                startLabel: '',
                endLabel: ''
            };
        case 'tickBoxGrid':
            return {
                type,
                label: 'Tick Box Grid',
                description: '',
                columns: [{id: generateUUID(), title: ''}],
                rows: [{id: generateUUID(), title: ''}],
                allowCustomRows: false
            };
        case 'multipleChoiceGrid':
            return {
                type,
                label: 'Multiple Choice Grid',
                description: '',
                columns: [{id: generateUUID(), title: ''}],
                rows: [{id: generateUUID(), title: ''}],
                allowCustomRows: false
            };
        case 'dropdown':
            return {
                type,
                label: 'Dropdown',
                description: '',
                options: [
                    {id: generateUUID(), description: ''},
                    {id: generateUUID(), description: ''},
                    {id: generateUUID(), description: ''}],
            };
        case FormBuilderComponentTypes.NumericInputBox:
            return {
                type: FormBuilderComponentTypes.NumericInputBox,
                label: 'Numeric Input',
                description: '',
            };
        case FormBuilderComponentTypes.OfferStatusChoice:
            return {
                type,
                label: 'Application Status Choice',
                description: 'Please select one of the options below to indicate your decision on the offer:',
                options: [
                    {id: generateUUID(), description: '', value: ''},
                    {id: generateUUID(), description: '', value: ''}]
            };
        case FormBuilderComponentTypes.FileUploader:
            return {
                type, label: 'File Uploader', description: '',
            };
        case FormBuilderComponentTypes.DateTime:
            return {
                type, label: 'Date and Time', description: '',
            };
        case FormBuilderComponentTypes.Date:
            return {
                type, label: 'Date', description: '',
            };
        case FormBuilderComponentTypes.Dropdown:
            return {
                label: 'Dropdown',
                type: 'dropdown',
                description: 'Dropdown Question?',
                options: [{id: generateUUID(), description: 'Option 1'}],
                enableValidation: true
            }
        case FormBuilderComponentTypes.LookupDropdown:
            return {
                label: 'Lookup Dropdown',
                type: 'lookupDropdown',
                description: 'Dropdown Question?',
                lookupType: '',
                options: [],
                enableValidation: true
            }
        case FormBuilderComponentTypes.Address:
            return {
                type: FormBuilderComponentTypes.Address,
                label: 'Address',
                description: '',
                enableValidation: false
            };
        case FormBuilderComponentTypes.IntakeChoice:
            return {
                type: FormBuilderComponentTypes.IntakeChoice,
                label: 'Intake Choice',
                description: 'Please select an intake:',
                options: [
                    {id: generateUUID(), description: '', value: ''},
                    {id: generateUUID(), description: '', value: ''}],
                enableValidation: true
            };
        case FormBuilderComponentTypes.BoarderStatusChoice:
            return {
                type: FormBuilderComponentTypes.BoarderStatusChoice,
                label: 'Boarder Status Choice',
                description: 'Select your preferred boarder status.',
                options: [
                    { id: generateUUID(), description: '', value: '' },
                    { id: generateUUID(), description: '', value: '' }
                ],
                enableValidation: true
            };
        case 'questionGrid':
            return {
                type,
                label: 'Question Grid',
                description: '',
                inputs: [
                    { id: generateUUID(), title: '', required: false },
                    { id: generateUUID(), title: '', required: false }
                ],
                allowCustomRows: false
            };
        case 'separator':
            return {
                type,
                label: 'Separator',
                description: '',
                alignment: 'center'
            };
        case FormBuilderComponentTypes.UPN:
            return {
                type: FormBuilderComponentTypes.UPN,
                label: 'UPN',
                description: 'Please enter the Unique Pupil Number (UPN).',
                key: 'upn',
                enableValidation: false
            };
        case FormBuilderComponentTypes.PreviousSchoolName:
            return {
                type: FormBuilderComponentTypes.PreviousSchoolName,
                label: 'Previous School Name',
                description: 'Please enter the name of the previous school.',
                key: 'previousSchoolName',
                enableValidation: false
            };
        case FormBuilderComponentTypes.PreviousSchoolEmail:
            return {
                type: FormBuilderComponentTypes.PreviousSchoolEmail,
                label: 'Previous School Email',
                description: 'Please enter the email address of the previous school.',
                key: 'previousSchoolEmail',
                enableValidation: false
            };
        case FormBuilderComponentTypes.EmployeeSelect:
            return {
                type: FormBuilderComponentTypes.EmployeeSelect,
                label: 'Employee Select',
                description: 'Please select an employee.',
                enableValidation: true
            };
        case FormBuilderComponentTypes.StudentPhoto:
            return {
                type: FormBuilderComponentTypes.StudentPhoto,
                label: 'Student Photo',
                description: '',
                alignment: 'left',
            };
        default:
            break;
    }
};